import { render } from "./BulkLocationUpdate.vue?vue&type=template&id=a2550e28"
import script from "./BulkLocationUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkLocationUpdate.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Inventory/BulkLocationUpdate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2550e28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2550e28', __exports__)) {
    api.reload('a2550e28', __exports__)
  }
  
  module.hot.accept("./BulkLocationUpdate.vue?vue&type=template&id=a2550e28", () => {
    api.rerender('a2550e28', render)
  })

}


export default __exports__